import { Config } from '@/config';
import apiService from '@/services/api.service';
import type { ConfigurationDto } from '@/store/configurationStore';

class ConfigurationsService {
  async getConfigurations(): Promise<ConfigurationDto[]> {
    try {
      const response = await apiService.get<ConfigurationDto[]>(`${Config.api.backend.urlV2}/configurations`);
      return response.data ?? [];
    } catch (error) {
      console.error('Failed to load configurations:', error);
      return [];
    }
  }
}

export const configurationsService = new ConfigurationsService();
